/**
Template de la scene THREE.JS
Nassim El Khantour 2022
Hesites pas a restructurer la Class comme tu veux.

THREE docu: https://threejs.org/docs/index.html#manual/en/introduction/Creating-a-scene
GTLFLoader docu: https://threejs.org/docs/index.html?q=gltf#examples/en/loaders/GLTFLoader
OrbitControls docu: https://threejs.org/docs/index.html?q=orbit#examples/en/controls/OrbitControls

*/
import * as THREE from 'three';

const BACKGROUND = 0x000000;             //background du Canvas
const INIT_WIDTH =  window.innerWidth;  //width du canvas
const INIT_HEIGHT = window.innerHeight; //height du canvas


export default class LogoScene{

  constructor({containerId, width, height, backgroundColor, objects, cameraPosX=0, cameraPosY=0.4, cameraZoom=3.8, orbit=false, grid=false}){

    this.renderer;
    this.scene;
    this.camera;
    this.width = width || INIT_WIDTH;
    this.height = height || INIT_HEIGHT;
    this.container = containerId || null;
    this.backgroundColor = backgroundColor || BACKGROUND;
    this.objects = objects || null;
    this.cameraPosX = cameraPosX;
    this.cameraPosY = cameraPosY;
    this.cameraZoom = cameraZoom;
    this.orbit = orbit;
    this.grid = grid;

  }

  spawn(){

      //check si le canvas est present dans le DOM
      this.container = typeof this.container == "string" ? document.getElementById(this.container) : this.container;
      if(!this.container){
        console.warn("Canvas element not found in DOM, check CanvasId parameter");
        return null;
      }

      //initialise la scene, le render et les events listeners
      this._init_();
      this._render_();
  }

  _init_(){

    //-------Setup le Renderer-------
    this.renderer = new THREE.WebGLRenderer({ alpha: true, antialias:true });
    this.renderer.setPixelRatio( window.devicePixelRatio );
    this.renderer.outputEncoding = THREE.sRGBEncoding;
    this.renderer.setClearColor( 0x000000, 0 )
    this.renderer.setSize(this.width,this.height);
    this.container.appendChild(this.renderer.domElement);    //append le render dans le canvas
    this.isPlaying = true;

    //-------Setup de la scene-------
    this.scene = new THREE.Scene();
    this.scene.background = null;

    //-------Setup de la camera-------
    this.camera = new THREE.PerspectiveCamera(50, this.width / this.height, 0.1, 1000 );
    this.camera.focalLength = 400;
    this.camera.position.z = 2.8;
    this.camera.position.y = this.cameraPosY;
    this.camera.position.x = this.cameraPosX;
    this.camera.rotation.x = -Math.PI/50;
    this.scene.add(this.camera); //ajout de la camera

    //------Setup grid------
    if(this.grid){
      const gridHelper = new THREE.GridHelper( 10, 10 );
      this.scene.add( gridHelper );
    }

    //------Setup Objects-----
    if(this.objects){
      for(const object of this.objects){
          this.scene.add(object);
      }
    }

  }

  _render_(){

    if(this.isPlaying){
      requestAnimationFrame( this._render_.bind(this) );
      this.renderer.render( this.scene, this.camera );
    }

  }

  pause(){
    this.isPlaying = false;
  }

  play(){
    this.isPlaying = true;
    this._render_();
  }


}
